import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { AIChatbotService } from '../../services/ai-chatbot/ai-chatbot.service';
import { AIChatbotMessage } from '../../models/ai-chatbot-message';

@Component({
  selector: 'ai-chatbot-prompt-box',
  templateUrl: './ai-chatbot-prompt-box.component.html',
  styleUrl: './ai-chatbot-prompt-box.component.scss',
  standalone: false,
})
export class AiChatbotPromptBoxComponent implements AfterViewInit {
  @ViewChild('messageInput') messageInput: ElementRef<HTMLTextAreaElement>;

  @Input() initialPrompt: string;
  @Input() selectedStyle: string;
  @Input() selectedContents: string[];
  @Input() selectedIndustry: string;

  constructor(public aiChatbotService: AIChatbotService) {}

  ngAfterViewInit(): void {
    this.setupTextareaAutoResize();
    if (this.initialPrompt) {
      this.messageInput.nativeElement.value = this.initialPrompt;
    }
  }

  private setupTextareaAutoResize(): void {
    const textarea = this.messageInput.nativeElement;
    textarea.addEventListener('input', () => {
      textarea.style.height = 'unset';
      textarea.style.height = textarea.scrollHeight + 'px';
      this.aiChatbotService.scrollChatToBottom$.next({ onlyIfAtBottom: true });
    });
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (!this.aiChatbotService.isProcessing) {
        this.sendMessage();
      }
    }
  }

  sendMessage(): void {
    const message = this.messageInput.nativeElement.value;
    if (!message.trim()) return;

    const userMessage: AIChatbotMessage = {
      id: this.aiChatbotService.generateMessageId(),
      timestamp: new Date(),
      role: 'user',
      content: {
        type: 'message',
        categories: {
          style: this.selectedStyle,
          contents: this.selectedContents
            ? Array.from(this.selectedContents)
            : undefined,
          industry: this.selectedIndustry,
        },
        message: message.trim(),
      },
    };

    this.messageInput.nativeElement.value = '';
    this.messageInput.nativeElement.style.height = 'unset';
    this.messageInput.nativeElement.focus();

    this.aiChatbotService.sendMessage(userMessage);
  }

  onStyleChange(style: string): void {
    this.selectedStyle = style;
  }

  onContentsChange(contents: string[]): void {
    this.selectedContents = contents;
  }

  onIndustryChange(industry: string): void {
    this.selectedIndustry = industry;
  }
}
